// extracted by mini-css-extract-plugin
export default {"header-container":"bhg89C6wzS8Wxy7mH0qI","left-icon":"nkw3q10kuUIKAHlhCSPo","telephone-icon":"QOMv2UlNEMg1q2YDsdEc","telephone-text":"d5RT3Yw4oUuzrPSGPARA"};